export const UPGRADE_REQUIRED_ERROR_CODE = 'client.upgradeRequired';
export const TOO_MANY_REQUESTS_ERROR_CODE = 'user.tooManyRequests';
